import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {USERS_SECURITY, USERS_SECURITY_API_URL, GET_ALL_USERS_SECURITY_API_URL} from 'constants/AppConstants';
import { USER_All_INFORMATION } from "constants/AuthConstant";
import CommonService from 'services/CommonService/CommonService';
import IntlMessage from "components/util-components/IntlMessage";
const setLocale = (localeKey, isLocaleOn = true) =>
  isLocaleOn ? <IntlMessage id={localeKey} /> : localeKey.toString();
const permission = JSON.parse(localStorage.getItem(USER_All_INFORMATION));

export const initialState = {
  UsersSecurityErrors       : {},
  permission: permission?.users_security ?? [],
  UsersSecurityShowMessage  : null,
  UsersSecurityResult       : [],
  UsersSecurityButtonSpinner : false,
  UsersSecurityTableLoading : true,
  UsersSecurityAddDrawer    : false,
  UsersSecurityEditData     : [],
  UsersSecurityButtonAndModelLabel  : setLocale('userssecurity.add'),
  tablePagination: {
        current: 1,
        pageSize: 10,
        total: 0,
    },
    sorting: {},
    filter: {},
    ViewUsersSecurityData: [],
    ViewUsersSecurityLoader: true,
    DrawerStatus: 0,
};

export const createUsersSecurity = createAsyncThunk(
    "createUsersSecurity",
  async (data) => {
    try {
      const response = await CommonService.createAndUpdate(data, USERS_SECURITY_API_URL);
      return response;
    } catch (err) {
      throw new Error(JSON.stringify(err.response.data.errors)); // Throw an error with the server response errors
    }
  }
);

export const getUsersSecurity = createAsyncThunk(
    "getUsersSecurity",
  async (data) => {
    try {
      const response = await CommonService.getAllPost(data, GET_ALL_USERS_SECURITY_API_URL);
      return response;
    } catch (err) {
      throw new Error(JSON.stringify(err.response.data.errors)); // Throw an error with the server response errors
    }
  }
);

export const viewUsersSecurity = createAsyncThunk(
  "viewUsersSecurity",
  async (id) => {
    try {
      const response = await CommonService.showOne(id, USERS_SECURITY_API_URL);
      return response;
    } catch (err) {
      throw new Error(JSON.stringify(err.response.data.errors)); // Throw an error with the server response errors
    }
  }
);

export const deleteUsersSecurity = createAsyncThunk(
  "deleteUsersSecurity",
  async (data) => {
    try {
      const response = await CommonService.deleteOne(data, USERS_SECURITY_API_URL);
      return response;
    } catch (err) {
      throw new Error(JSON.stringify(err.response.data.errors)); // Throw an error with the server response errors
    }
  }
);

export const manageUsersSecuritySlice = createSlice({
  name: USERS_SECURITY,
  initialState,
  reducers: {
    onCloseError: (state, action) => {
      state.UsersSecurityErrors = {};
    },
    UsersSecurityAddDrawerStatus: (state, action) => {
        if (action.payload.status === false) {
            state.UsersSecurityButtonSpinner = false;
      }
      state.UsersSecurityAddDrawer   = action.payload.status;
      state.DrawerStatus = action.payload.errorStatus;
      state.UsersSecurityEditData    = [];
      state.UsersSecurityButtonAndModelLabel = setLocale('userssecurity.add');
    },
    UsersSecurityEditWithDrawerStatus: (state, action) => {
      state.UsersSecurityAddDrawer = true;
      state.DrawerStatus = action.payload.errorStatus;
      state.UsersSecurityEditData = action.payload.data;
      state.UsersSecurityButtonAndModelLabel = setLocale('userssecurity.edit');
    },
    updateSortFilters: (state, action) => {
        state.filter = action.payload.filter;
        state.sorting = action.payload.sorting;
    },
    setColumnSearch: (state, action) => {
      state.filter = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createUsersSecurity.pending, (state, action) => {
        state.DrawerStatus = 0
        state.UsersSecurityButtonSpinner = true;
      }).addCase(createUsersSecurity.fulfilled, (state, action) => {
        state.DrawerStatus = 0
        state.UsersSecurityButtonSpinner = false;
        state.UsersSecurityErrors = {}
      }).addCase(createUsersSecurity.rejected, (state, action) => {
        state.DrawerStatus = 1
        state.UsersSecurityShowMessage = true;
        state.UsersSecurityButtonSpinner = false;
        state.UsersSecurityErrors = JSON.parse(action.error.message); // Parse the error messages and store them in the state
      }).addCase(getUsersSecurity.pending, (state, action) => {
        state.UsersSecurityButtonSpinner = true;
        state.UsersSecurityTableLoading = true;
      }).addCase(getUsersSecurity.fulfilled, (state, action) => {
        state.UsersSecurityButtonSpinner = false;
        state.UsersSecurityTableLoading = false;
        state.UsersSecurityResult = action.payload;
        state.tablePagination = {
            ...state.tablePagination,
            total: action.payload.pagination.total,
            current: action.payload.pagination.current_page,
            pageSize: action.payload.pagination.per_page
        };
      }).addCase(getUsersSecurity.rejected, (state, action) => {
        state.UsersSecurityShowMessage = true; // Set the showMessage flag to display the errors
        state.UsersSecurityButtonSpinner = false;
        state.UsersSecurityTableLoading = false;
        state.UsersSecurityErrors = JSON.parse(action.error.message); // Parse the error messages and store them in the state
      })
      .addCase(viewUsersSecurity.pending, (state, action) => {
        state.ViewUsersSecurityLoader = true;
        state.ViewUsersSecurityData = [];
      }).addCase(viewUsersSecurity.fulfilled, (state, action) => {
        state.ViewUsersSecurityLoader = false;
        state.ViewUsersSecurityData = action.payload;
      }).addCase(viewUsersSecurity.rejected, (state, action) => {
        state.ViewUsersSecurityLoader = false;
        state.ViewUsersSecurityData = [];
      })
      .addCase(deleteUsersSecurity.pending, (state, action) => {
        state.UsersSecurityTableLoading = true;
      }).addCase(deleteUsersSecurity.fulfilled, (state, action) => {
        state.UsersSecurityTableLoading = false;
      }).addCase(deleteUsersSecurity.rejected, (state, action) => {
        state.UsersSecurityTableLoading = false;
      });
  },
});

export const { onCloseError, setColumnSearch, UsersSecurityAddDrawerStatus, UsersSecurityEditWithDrawerStatus, updateSortFilters } = manageUsersSecuritySlice.actions;

export default manageUsersSecuritySlice.reducer;